import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { company, navLinks, services } from '../mock/mock';
import BrandMark from './BrandMark';

const Footer = () => {
  return (
    <footer className="bg-[var(--rs-ink)] text-[var(--rs-cream)] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 pt-20 pb-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-8">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <BrandMark size={44} />
              <div>
                <div className="h-display text-xl text-[var(--rs-green2)]">Residential Support</div>
              </div>
            </div>
            <p className="mt-6 text-[var(--rs-cream)]/70 max-w-md">
              The outsourcing backbone of modern UK letting agencies. Check-in and check-out inventories, viewings, photography and floor plans — one trusted partner.
            </p>

            <div className="mt-8 space-y-3 text-sm">
              <a href={`tel:${company.phone}`} className="flex items-center gap-3 hover:text-[var(--rs-coral)]">
                <Phone className="w-4 h-4" /> {company.phone}
              </a>
              <a href={`mailto:${company.email}`} className="flex items-center gap-3 hover:text-[var(--rs-coral)]">
                <Mail className="w-4 h-4" /> {company.email}
              </a>
              <div className="flex items-center gap-3 text-[var(--rs-cream)]/70">
                <MapPin className="w-4 h-4" /> {company.address}
              </div>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="text-xs uppercase tracking-[0.2em] text-[var(--rs-cream)]/50 mb-4">Company</div>
            <ul className="space-y-2.5">
              {navLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-[var(--rs-cream)]/85 hover:text-[var(--rs-coral)] text-sm">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="text-xs uppercase tracking-[0.2em] text-[var(--rs-cream)]/50 mb-4">Services</div>
            <ul className="space-y-2.5">
              {services.map((s) => (
                <li key={s.id}>
                  <Link to={`/services/${s.id}`} className="text-[var(--rs-cream)]/85 hover:text-[var(--rs-coral)] text-sm">{s.title}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-[var(--rs-cream)]/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-[var(--rs-cream)]/55">© {new Date().getFullYear()} Agents Support Ltd T/A Residential Support. Registered in England &amp; Wales, company no. 1624825.</p>
          <div className="flex items-center gap-5 text-xs text-[var(--rs-cream)]/55">
            <Link to="/privacy" className="hover:text-[var(--rs-coral)]" data-testid="footer-privacy-link">Privacy</Link>
            <Link to="/terms" className="hover:text-[var(--rs-coral)]" data-testid="footer-terms-link">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
